export class ListBackupPolicyResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backupPolicies",
            "baseName": "backupPolicies",
            "type": "Array<BackupPolicyConfigResponse>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListBackupPolicyResponse.attributeTypeMap;
    }
    constructor() {
    }
}
